export default [
  {
    name: 'report-portal',
    path: 'report',
    component: () => import(/* webpackChunkName: "report" */ './index.vue')
  }
]
